import { SoftwareApi } from "@vintecc/capture-api-types/v1";
import captureApiConfiguration from "./configuration.api";

const software = new SoftwareApi(captureApiConfiguration);

export default software;
